import { useDebounce } from '../../common/hooks/useDebounce';

import type { PriceCompareFormValues } from './types/PriceCompareFormValues';
import { useMappedPriceCompare } from './useMappedPriceCompare';
import { calculatePriceCompareItem } from './utils/calculatePriceCompareItem';

interface UsePriceCompareOptions {
    values: PriceCompareFormValues;
    enabled?: boolean;
    defaultContractId?: string;
    deliveryDate?: string;
}

export const usePriceCompare = ({
    values,
    enabled = true,
    defaultContractId,
    deliveryDate,
}: UsePriceCompareOptions) => {
    const debouncedValues = useDebounce(values, 500);
    const items = debouncedValues.items.map(calculatePriceCompareItem).filter((item) => Boolean(item.isComplete()));
    const portIds = debouncedValues.portInformation.flatMap((port) => (port.portId ? [port.portId] : []));
    const customerIds = debouncedValues.customerId ? [debouncedValues.customerId] : [];
    const resolvedDefaultContractId = defaultContractId ?? debouncedValues.vessel?.defaultContractId;

    return useMappedPriceCompare({
        defaultContractId: resolvedDefaultContractId,
        items,
        portIds,
        customerIds,
        vesselId: debouncedValues.vesselId || undefined,
        deliveryDate,
        enabled: items.length > 0 && portIds.length > 0 && customerIds.length > 0 && enabled,
    });
};
